interface DirectAccessCredentials {
	t: string;
	h: string;
}

const directAccessCookieName = (bookingId: string, conferenceId: string): string => `conf_${bookingId}_${conferenceId}`;

export const isDirectAccessCookieEntry = (searchParams: URLSearchParams, pathname: string): boolean =>
	!searchParams.has("t") && /^\/host\/[^/]+\/[^/]+\/?$/.test(pathname);

export const readDirectAccessCookie = (bookingId: string | undefined, conferenceId: string | undefined): DirectAccessCredentials | null => {
	if (!bookingId || !conferenceId) return null;
	const prefix = `${directAccessCookieName(bookingId, conferenceId)}=`;
	const cookie = document.cookie.split(";").map(value => value.trim()).find(value => value.startsWith(prefix));
	if (!cookie) return null;
	try {
		const credentials: unknown = JSON.parse(decodeURIComponent(cookie.slice(prefix.length).replace(/\+/g, " ")));
		if (typeof credentials !== "object" || credentials === null
			|| !("t" in credentials) || typeof credentials.t !== "string" || !credentials.t
			|| !("h" in credentials) || typeof credentials.h !== "string" || !credentials.h) {
			throw new Error("Invalid conference access cookie.");
		}
		return { t: credentials.t, h: credentials.h };
	} catch {
		console.error("Invalid conference access cookie.");
		return null;
	}
};

export const clearDirectAccessCookie = (bookingId: string, conferenceId: string): void => {
	document.cookie = `${directAccessCookieName(bookingId, conferenceId)}=; Max-Age=0; Path=/host/${bookingId}/${conferenceId}; Domain=media-server.com; Secure; SameSite=Strict`;
};
